module.exports = __webpack_public_path__ + "static/img/table.4cd25bec.svg";